import { filterDataBySchema } from './filterByJsonSchema';
import { getDefaultSettingsValue } from './getDefaultSettings';
import type { AgentWidgetSettings, FormJsonData } from '../../../api';

export function normalizeAgentWidgetSettingsForForm(
  apiData: AgentWidgetSettings,
  schema: FormJsonData
): Record<string, unknown> {
  const filtered = apiData.widgetSettings
    ? filterDataBySchema(
        apiData.widgetSettings as AgentWidgetSettings,
        schema.jsonSchema
      )
    : {};

  const defaults = getDefaultSettingsValue(schema.jsonSchema.properties);

  return { ...defaults, ...filtered };
}
